import { useRef, BaseSyntheticEvent } from 'react'

import { usePostResetPassword } from 'services/auth'
import { joiResolver } from '@hookform/resolvers/joi'
import { useForm } from 'react-hook-form'
import { useToast } from 'shared/hooks'

import { Button, Modal, Text } from 'components'
import { TextField } from 'uikit'

import { Loader } from '../../components'
import { resetPasswordSchema } from '../../../../schemas'
import styles from './styles.module.scss'

interface FormData {
  email: string
}

const ResetPassword = () => {
  const closeButtonRef = useRef<HTMLButtonElement>(null)

  const {
    register,
    handleSubmit,
    formState: { isDirty, errors },
  } = useForm<FormData>({
    mode: 'onSubmit',
    defaultValues: {
      email: '',
    },
    resolver: joiResolver(resetPasswordSchema),
  })

  const { mutate, isLoading } = usePostResetPassword()

  const { addToast } = useToast()

  const onSubmit = ({ email }: FormData) => {
    mutate(
      { email },
      {
        onSuccess: () => {
          addToast({
            message: 'Email de recuperação de senha enviado com sucesso.',
          })

          closeButtonRef?.current?.click()
        },
        onError: () => {
          addToast({
            message:
              'Erro ao enviar email de recuperação de senha. Tente novamente.',
            type: 'alert',
          })
        },
      },
    )
  }

  return (
    <>
      {isLoading && <Loader />}

      <Modal.Title>Recuperação de senha</Modal.Title>

      <form
        className={styles.form}
        onSubmit={(e) => {
          e.stopPropagation()
          handleSubmit(onSubmit)(e)
        }}
      >
        <div className={styles.content}>
          <Text weight="regular">
            Digite seu e-mail para receber as instruções de redefinição de
            senha.
          </Text>

          <TextField
            {...register('email')}
            label="Email"
            spellCheck="false"
            message={errors?.email?.message}
            appearance={errors?.email ? 'error' : 'neutral'}
          />
        </div>

        <Modal.Footer>
          <Modal.Close>
            <Button type="button" appearance="tertiary" ref={closeButtonRef}>
              Cancelar
            </Button>
          </Modal.Close>

          <Button disabled={!isDirty} width={87} type="submit">
            Enviar
          </Button>
        </Modal.Footer>
      </form>
    </>
  )
}

export default ResetPassword
